import { render, staticRenderFns } from "./YoutubeIcon.vue?vue&type=template&id=e6c24d68&scoped=true"
import script from "./YoutubeIcon.vue?vue&type=script&lang=js"
export * from "./YoutubeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c24d68",
  null
  
)

export default component.exports